import React from 'react';

import { Text } from '@reckon-web/text';

import { Dialog } from '../components/common/dialog';
import { createFileName } from '../utils/filename-utils';
import { ExportWorkType } from '../types/export-work-type';

import { useDialog } from './use-dialog';
const ConfirmationDialog: React.FC<{
  count: number;
  onClose: (ok?: boolean) => void;
  onSubmit: () => void;
}> = ({ count, onClose, onSubmit }) => {
  return (
    <Dialog
      title={`Export ${count} items to .CSV?`}
      cancelLabel="Cancel"
      onCancel={onClose}
      submitLabel="Yes, export"
      onSubmit={() => {
        onClose(true);
        return onSubmit();
      }}
    >
      <Text>
        Only current fields and properties will be included in the CSV file.
      </Text>
    </Dialog>
  );
};
export const useExportToCsv = () => {
  const [Dialog, openDialog] = useDialog();
  const exportToCsv = React.useCallback(
    async ({
      exportWorkType,
      csv,
      count,
      filterName,
    }: {
      exportWorkType: ExportWorkType;
      csv: string;
      count: number;
      filterName?: string;
    }) => {
      const setDownload = () => {
        const blob = new Blob([csv]);
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = `${createFileName(exportWorkType, filterName)}.csv`;
        a.click();
        return URL.revokeObjectURL(a.href);
      };
      if (
        !(await openDialog<boolean>(
          (props) => (
            <ConfirmationDialog
              count={count}
              onSubmit={setDownload}
              {...props}
            />
          ),
          { size: 'small' }
        ))
      )
        return;
    },
    [openDialog]
  );
  return React.useMemo(
    () => [Dialog, exportToCsv] as [typeof Dialog, typeof exportToCsv],
    [Dialog, exportToCsv]
  );
};
